module.exports = __webpack_public_path__ + "static/img/active_05.73525e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_05.jpg
// module id = u02d
// module chunks = 0